import React from 'react'
import PropTypes from 'prop-types'

const InfoSection = ({ partnerName, disabledFields }) => (
  <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
    { disabledFields ? <p className='txt-subtitle txt-font-body color-ui-2'>Selecione um parceiro para transferir seus reales</p> : <p className='txt-subtitle txt-font-body color-ui-2'>
      Seus Reales estão sendo transferidos para {partnerName}.
    </p>}
  </div>
)

InfoSection.propTypes = {
  partnerName: PropTypes.string,
  disabledFields: PropTypes.bool
}

export default InfoSection



// WEBPACK FOOTER //
// ./src/features/MileageRescue/Sidebar/InfoSection.js